import React from 'react';

type LoaderProps = {
  width?: string;
  borderTopColor?: string; // Prop to customize the top border color
  className?: string;
};

const Loader: React.FC<LoaderProps> = ({
  width = '20px',
  borderTopColor = 'border-t-deepGreen', // Default color
  className,
}) => (
  <div
    style={{ width, height: width }}
    className={`border-4 border-gray-300 animate-spin rounded-full ${borderTopColor} ${className}`}
  />
);

export default Loader;
